export default __webpack_public_path__ + "./image/859086d7f1ffb76e0cae0af73ec7e40a.png";